var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.embed)?_c('div',[_vm._t("default")],2):_c('div',{class:[
    _vm._.page,
    _vm.whiteBack && _vm._.whiteBack,
    _vm.onlyBack && _vm._.onlyBack,
    _vm.whiteBackground && _vm._.whiteBackground,
    (_vm.transparentHeader || _vm.classical) && _vm._.transparentHeader,
    _vm.noHeaderShadow && _vm._.noHeaderShadow,
    _vm.titleAdaptive && _vm._.titleAdaptive,
    !_vm.noSafeArea && _vm._.safeArea,
    _vm.loading && _vm._.loading,
    (_vm.$slots.header || _vm.$scopedSlots.header) && _vm._.customHeader ],style:(Object.assign({}, (_vm.customBackground && !_vm.loading
      ? { backgroundColor: _vm.customBackground }
      : {}),
    {'--real-page-header-height':
      _vm.transparentHeader || _vm.classical ? 'var(--page-header-height)' : '0px'}))},[(
      (_vm.$state.inDcb || _vm.$state.inLove) &&
      !((_vm.transparentHeader || _vm.classical) && _vm.loading)
    )?_c('div',{class:[_vm._.hd, '__page_header__'],style:({
      backgroundColor:
        _vm.classical && _vm.classicalScrollBackgroundColor
          ? !_vm.headerParallaxRate
            ? 'transparent'
            : _vm.classicalScrollBackgroundColor
          : _vm.headerBackgroundColorWhenScroll
          ? !_vm.headerParallaxRate
            ? 'transparent'
            : _vm.headerBackgroundColorWhenScroll
          : _vm.classical
          ? !_vm.headerParallaxRate
            ? 'transparent'
            : ("rgba(255, 255, 255, " + _vm.headerParallaxRate + ")")
          : _vm.headerBackgroundColor || undefined,
      backgroundImage:
        (_vm.headerBackgroundImage && ("url('" + _vm.headerBackgroundImage + "')")) ||
        undefined,
    })},[_vm._t("header",function(){return [_c('x-icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.noBack),expression:"!noBack"}],class:[_vm._.back, '__page_back__'],style:(_vm.classical
            ? {
                color:
                  _vm.classical && _vm.classicalScrollBackgroundColor
                    ? 'white'
                    : !_vm.headerParallaxRate
                    ? 'white'
                    : ("rgba(0, 0, 0, " + _vm.headerParallaxRate + ")"),
              }
            : {}),attrs:{"name":"back"},on:{"click":_vm.handleBackClick}}),_vm._t("left"),_c('div',{class:_vm._.grow}),_c('div',{class:[_vm._.title, _vm._._ellipsis, '__page_title__'],style:(_vm.classical
            ? !_vm.headerParallaxRate
              ? {
                  visibility: 'hidden',
                }
              : {
                  color: _vm.classicalScrollBackgroundColor
                    ? 'white'
                    : ("rgba(0, 0, 0, " + _vm.headerParallaxRate + ")"),
                }
            : {})},[(_vm.title)?[_vm._v(_vm._s(_vm.title))]:_vm._t("title")],2),_c('div',{class:_vm._.extra},[_vm._t("extra",function(){return [(_vm.share.title)?_c('x-icon',{directives:[{name:"track",rawName:"v-track",value:({
              name: '分享',
              id: '0e09202c-7927-454e-b343-0783a728f3c3',
            }),expression:"{\n              name: '分享',\n              id: '0e09202c-7927-454e-b343-0783a728f3c3',\n            }"}],class:_vm._.share,style:(_vm.classical
                ? {
                    color:
                      _vm.classical && _vm.classicalScrollBackgroundColor
                        ? 'white'
                        : !_vm.headerParallaxRate
                        ? 'white'
                        : ("rgba(0, 0, 0, " + _vm.headerParallaxRate + ")"),
                  }
                : {}),attrs:{"name":"share"},on:{"click":_vm.handleShareClick}}):_vm._e()]})],2)]},{"headerParallaxRate":_vm.headerParallaxRate,"handleBackClick":_vm.handleBackClick,"pageHeaderHeight":_vm.pageHeaderHeight})],2):_vm._e(),_c('div',{class:_vm._.placeholder}),_c('div',{class:_vm._.bd},[(_vm.$globalModel.state.isAccessDenied)?_c('div',[_c('x-empty',{attrs:{"message":_vm.$globalModel.state.fromTV
            ? ("请使用当前TV端登录的多彩宝账号（" + (_vm.$globalModel.state.fromUser) + "）扫码查询")
            : '您无权限访问该页面'}})],1):(_vm.loading)?_c('div',{class:_vm._.loading},[_c('x-lottie',{class:_vm._.icon,attrs:{"data":_vm.pageLoadingData}}),_c('div',{class:_vm._.tips},[_vm._v("加载中...")])],1):_c('div',{ref:"container",class:[_vm._.container, '__page_container__']},[_vm._t("default"),_c('div',{class:_vm._.tabbarHolder})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }